import pathfinder from '@fiverr-private/pathfinder';
import { PATHFINDER, formatQueryParams } from '../../utils';

export const getStorePath = ({ slug, queryParams, source }) => {
    const params = { store_name: slug };
    return pathfinder(PATHFINDER.STORE, params, formatQueryParams({ queryParams, source }));
};
